import React from "react";
import { useLocation } from "react-router-dom";
import Seo from "@/components/Seo";
import { ORG, SITE_ORIGIN } from "@/lib/seo";
import { useSiteContent } from "@/lib/siteContent";

const D = "Molar Kimya; laboratuvar kimyasalları, cihazları, sarf malzemeleri ve gıda hammaddeleri için B2B ürün kataloğu ve teklif platformu.";

const STATIC = {
  "/": ["Molar Kimya | Ürün Kataloğu ve Teklif Platformu", D],
  "/sektorler": ["Sektörler | Molar Kimya", "Gıda, laboratuvar ve endüstriyel sektörlere göre kimyasal ve ekipman ürünlerini inceleyin."],
  "/kullanim-alanlari": ["Kullanım Alanları | Molar Kimya", "Kullanım alanına göre kimyasal, katkı ve laboratuvar ürünlerini bulun, teklif isteyin."],
  "/hakkimizda": ["Hakkımızda | Molar Kimya", "Molar Kimya; Gaziantep merkezli, kimyasal ve laboratuvar ürünleri tedarikçisi ve dağıtıcısıdır."],
  "/tedarik-sureci": ["Tedarik Süreci | Molar Kimya", "Teklif talebinden sevkiyata Molar Kimya tedarik sürecinin adımları."],
  "/iletisim": ["İletişim | Molar Kimya", "Molar Kimya iletişim bilgileri: adres, telefon, e-posta ve sevk noktaları."],
  "/gizlilik": ["Gizlilik Politikası | Molar Kimya", "Molar Kimya ürün kataloğu ve teklif platformu gizlilik politikası."],
  "/aydinlatma": ["Aydınlatma Metni | Molar Kimya", "Kişisel verilerin işlenmesine ilişkin aydınlatma metni."],
  "/sss": ["Sık Sorulan Sorular | Molar Kimya", "Molar Kimya teklif, tedarik ve sevkiyat süreçleri hakkında sık sorulan sorular."],
};

const PRIVATE = [
  ["/teklif-iste", "Teklif Talebi | Molar Kimya"], ["/teklif-takip", "Teklif Takibi | Molar Kimya"],
  ["/teklif/", "Teklif | Molar Kimya"], ["/giris", "Giriş | Molar Kimya"], ["/kayit", "Kayıt | Molar Kimya"],
  ["/sifremi-unuttum", "Şifre Sıfırlama | Molar Kimya"], ["/sifre-sifirla", "Şifre Sıfırlama | Molar Kimya"],
  ["/hesabim", "Hesabım | Molar Kimya"], ["/yonetim", "Yönetim Paneli | Molar Kimya"],
];

const orgLd = () => ({
  "@context": "https://schema.org", "@type": "Organization", ...ORG,
  alternateName: "Molar Kimya", url: SITE_ORIGIN,
  description: "Kimyasal, laboratuvar ve gıda hammaddeleri tedarikçisi ve dağıtıcısı (üretici değildir).",
});

// Statik sayfaların SEO etiketleri; ürün, kategori ve katalog sayfaları kendi etiketlerini üretir
export default function TitleManager() {
  const { pathname } = useLocation();
  const sc = useSiteContent();
  if (STATIC[pathname]) {
    const o = sc?.sayfa_seo?.[pathname === "/" ? "ana-sayfa" : pathname.slice(1)] || {};
    const title = o.title || STATIC[pathname][0];
    const desc = o.description || STATIC[pathname][1];
    const ld = pathname === "/" ? [orgLd(), { "@context": "https://schema.org", "@type": "WebSite",
      name: "Molar Kimya", url: SITE_ORIGIN, inLanguage: "tr-TR" }]
      : pathname === "/iletisim" ? [orgLd()] : [];
    return <Seo title={title} description={desc} path={pathname} jsonLd={ld} />;
  }
  const priv = PRIVATE.find(([p]) => pathname.startsWith(p));
  if (priv) return <Seo title={priv[1]} noindex />;
  return null;
}
